import { useState } from "react";
import { Box, Card, CardContent, Tab, Tabs, ThemeProvider, createTheme } from "@mui/material";
import FileUpload from "./FileUpload";
import TripHistoryList from "./TripHistory";

const theme = createTheme({
    palette: {
        mode: 'light',
        background: { default: '#fff' },
    },
});

const UploadTrips = () => {
    const [value, setValue] = useState(0);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const isTrips = window.location.pathname.includes('upload-trip');

    return (
        <>
            <ThemeProvider theme={theme}>
                <Card>
                    <CardContent>
                        <Box>
                            <Box>
                                <Tabs value={value} onChange={handleChange} centered>
                                    <Tab label={isTrips ? `Upload Bulk Trips` : `Upload Bulk Trucks`} />
                                    <Tab label={isTrips ? `Trip Uploaded History` : `Truck Uploaded History`} />
                                </Tabs>
                            </Box>
                            {value === 0 && <FileUpload isTrips={isTrips} />}
                            {(value === 1) && <TripHistoryList isTrips={isTrips} />}
                        </Box>
                    </CardContent>
                </Card>
            </ThemeProvider>
        </>
    );
};

export default UploadTrips;
